"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import DocumentThumbnail from "./document_thumbnail";
import reactUtils from "../react_utils";
import "../components/waiting_spinner";
import Auth from "../util/auth";
import { doctypeGroupings } from "./grouped_document_browser_model";
import {
  documentHasReferenceMatchForLoad,
  documentHasMissingReferenceMatchForLoad,
  isPodForLoad
} from "./helpers/document_load_relationship_helpers";
import Account from "../api/account";
var bem = reactUtils.makeBem("document-thumbnail-list");
function waitingSpinner(loading) {
  if (loading) {
    return /* @__PURE__ */ React.createElement("div", { className: "document-thumbnail--loading" }, "Loading...");
  }
}
function showRelatedDocument(props, document) {
  const hasReferenceMatch = false;
  const missingReferenceMatch = false;
  const isPod = document.is_pod;
  return /* @__PURE__ */ React.createElement(
    DocumentThumbnail,
    {
      document,
      key: document.id,
      variant: props.variant,
      onContextMenu: props.onContextMenu,
      pageSelected: props.pageSelected,
      selectedPages: props.selectedPages,
      isDocumentGrouper: props.isDocumentGrouper,
      hasReferenceMatch,
      missingReferenceMatch,
      isPodForLoad: isPod
    }
  );
}
function RelatedDocumentList(props) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-component": "RelatedDocumentList",
      className: bem("related-container")
    },
    /* @__PURE__ */ React.createElement("div", { className: bem("related-container-title") }, props.title),
    waitingSpinner(props.loading),
    props.documents.map((document) => showRelatedDocument(props, document))
  );
}
function renderEntries(props) {
  if (props.isDocumentGrouper || !Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled) {
    return _.map(
      documentsInSelectedGroups(props),
      (documents) => showDraggableThumbnailGroup(props, documents)
    );
  }
  const documentsInGroups = documentsInSelectedGroups(props);
  const documentTypes = _.groupBy(
    documentsInGroups,
    (document) => document[0].type
  );
  const sortedDocumentTypes = doctypeGroupings(props.documents);
  const entries = sortedDocumentTypes.map((type) => {
    var _a, _b, _c, _d;
    const groupedDocuments = documentTypes[type].sort(
      (a, b) => a[0].id - b[0].id
    );
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: ((_d = (_c = (_b = (_a = Auth) == null ? void 0 : _a._currentUser) == null ? void 0 : _b.account) == null ? void 0 : _c.settings) == null ? void 0 : _d.documents_viewer_doctype_grouping_enabled) ? "document-browser__grouped-by-doctype" : ""
      },
      /* @__PURE__ */ React.createElement("div", { className: "document-thumbnail__title document-thumbnail__doctype" }, groupedDocuments[0][0].type_name),
      _.map(
        groupedDocuments,
        (documents) => showDraggableThumbnailGroup(props, documents)
      )
    );
  });
  return entries;
}
function documentsInSelectedGroups(props) {
  let currentArray = [];
  return _.reduce(
    props.documents,
    (memo, document) => {
      const isSelected = _.find(
        selectedPages(props),
        (page) => page.id === document.pages[0].id
      );
      if (isSelected) {
        currentArray.push(document);
        if (currentArray.length === selectedPages(props).length) {
          memo.push(currentArray);
          currentArray = [];
        }
      } else {
        memo.push([document]);
      }
      return memo;
    },
    []
  );
}
function showDraggableThumbnailGroup(props, documents) {
  const key = "documents-" + documents.map((document) => document.id).join("-");
  return /* @__PURE__ */ React.createElement("div", { className: "draggable-thumbnail-group", key }, _.map(documents, (document) => showDocument(props, document)));
}
function showDocument(props, document) {
  const load = props.selectedLoad || props.loadState;
  let hasReferenceMatch = false;
  let missingReferenceMatch = false;
  if (Account.currentSettings().pod_requires_bol_validation) {
    hasReferenceMatch = documentHasReferenceMatchForLoad(
      document,
      load,
      props.documentLoadRelationships
    );
    missingReferenceMatch = documentHasMissingReferenceMatchForLoad(
      document,
      load,
      props.documentLoadRelationships
    );
  }
  const isPod = isPodForLoad(document, load, props.documentLoadRelationships);
  return /* @__PURE__ */ React.createElement(
    DocumentThumbnail,
    {
      document,
      key: document.id,
      variant: props.variant,
      onContextMenu: props.onContextMenu,
      pageSelected: (page, options) => pageSelected(props, page, options),
      selectedPages: selectedPages(props),
      isDocumentGrouper: props.isDocumentGrouper,
      hasReferenceMatch,
      missingReferenceMatch,
      isPodForLoad: isPod
    }
  );
}
function noSelectedPages(props) {
  const pages = props.documents.map((document) => document.pages[0]);
  return _.isEmpty(_.intersection(pages, selectedPages(props)));
}
function pageSelected(props, selectedPage, options = {}) {
  const { action } = options;
  if (action === "replace" || noSelectedPages(props)) {
    setSelectedPages(props, [selectedPage], selectedPage);
  } else if (action === "add") {
    const pages = props.documents.map((document) => document.pages[0]);
    const anchorPageIndex = pages.indexOf(props.anchorPage);
    const selectedPageIndex = pages.indexOf(selectedPage);
    let minIndex = anchorPageIndex;
    let maxIndex = selectedPageIndex;
    if (selectedPageIndex < anchorPageIndex) {
      minIndex = selectedPageIndex;
      maxIndex = anchorPageIndex;
    }
    const selectedPages2 = pages.slice(minIndex, maxIndex + 1);
    setSelectedPages(props, selectedPages2, props.anchorPage);
  }
}
function setSelectedPages(props, selectedPages2, anchorPage) {
  props.setSelectedPages(selectedPages2, anchorPage);
}
function selectedPages(props) {
  return props.selectedPages;
}
function possibleRelatedDocuments(props) {
  if (props.relatedDocuments && props.relatedDocuments.length > 0) {
    return /* @__PURE__ */ React.createElement(
      RelatedDocumentList,
      __spreadProps(__spreadValues({}, props), {
        pageSelected: (page, options) => pageSelected(props, page, options),
        selectedPages: selectedPages(props),
        loading: props.relatedDocumentsLoading,
        documents: props.relatedDocuments,
        title: props.relatedDocumentsTitle
      })
    );
  }
}
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem(this.props.variant) }, renderEntries(this.props), possibleRelatedDocuments(this.props));
  }
});
